import { Box, Button, Typography } from '@mui/material';
import React from 'react';

import { getCheckpointById } from '../config';
import { useCheckpoints } from '../lib/CheckpointsContext';

const CheckpointsFound: React.FC = () => {
  const { items, clearItems } = useCheckpoints();

  return (
    <Box>
      {items?.length > 0 && (
        <Typography variant="subtitle1" component="h1" gutterBottom>
          Löydetyt rastit:
        </Typography>
      )}
      {items?.map((checkpointId: string) => (
        <Button
          key={checkpointId}
          sx={{ m: 1 }}
          href={`/checkpoint/${checkpointId}`}
          variant="contained"
          color="primary"
        >
          {getCheckpointById(checkpointId)?.name}
        </Button>
      ))}

      <Button
        sx={{ m: 1 }}
        variant="contained"
        color="warning"
        onClick={clearItems}
      >
        Tyhjennä
      </Button>
    </Box>
  );
};

export default CheckpointsFound;
